package ru.it_mozaika.sender.js.application.frames.subscribers

import csstype.PropertiesBuilder
import io.ktor.client.call.*
import io.ktor.http.*
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import mui.icons.material.Cancel
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.onChange
import react.router.useNavigate
import react.router.useParams
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.common.models.Property
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.subscribers.subscriptionDialog
import ru.it_mozaika.sender.js.application.context.*
import ru.it_mozaika.sender.js.application.frames.MainCard
import ru.it_mozaika.sender.js.application.toLocalString
import web.cssom.*
import web.html.InputMode
import web.html.InputType

val subscriberFrame = FC<Props> {
    val theme = useTheme<Theme>()
    val params = useParams()
    val id = params["id"].orEmpty()
    val storeContext = useContext(StoreContext)
    val sublistContext = useSubscriptionLists()
    val subscriberContext = useContext(SubscriberContext)
    val currentSubscriber = useMemo(subscriberContext.currentSubscriber) { subscriberContext.currentSubscriber }
    val updatedSubscriber = useMemo(subscriberContext.updatedSubscriber) { subscriberContext.updatedSubscriber }
    val propertiesContext = useContext(PropertiesContext)
    var showSubscribeDialog by useState(false)
    var showUnSubscribeDialog by useState(false)
    var emailMessages by useState(listOf<EmailMessage>())
    val tags = listOf("tag1", "tag2", "tag3")
    val (selectedTags, setSelectedTags) = useState(tags)
    val requestResultContext = useContext(RequestResultContext)
    val navigate = useNavigate()
    var emailMessagesInProcess by useState(false)

    fun getEmailMessages() {
        emailMessagesInProcess = true
        Http.get(
            "/emails/message",
            query = mapOf("store" to storeContext.currentStoreId.orEmpty(), "id" to id)
        ) { response ->
            if (response.status == HttpStatusCode.OK) {
                emailMessages = response.body()
                emailMessagesInProcess = false
            } else {
                requestResultContext.handleRequestRespond(response)
                emailMessagesInProcess = false
            }
        }
    }
    useEffectOnce {
        getEmailMessages()
        subscriberContext.load(id)
    }
    subscriptionDialog {
        this.subscribers =
            useMemo(currentSubscriber) { if (currentSubscriber != null) listOf(currentSubscriber) else listOf() }
        this.isOpen = showSubscribeDialog || showUnSubscribeDialog
        this.subscribe = showSubscribeDialog
        this.onClose = {
            showSubscribeDialog = false
            showUnSubscribeDialog = false
        }
        this.requestHandler = {
            showSubscribeDialog = false
            showUnSubscribeDialog = false
            subscriberContext.load(id)
        }
    }
    Card {
        sx {
            this.backgroundColor = theme.palette.grey["100"].unsafeCast<Color>()
        }
        CardHeader {
            this.title = ReactNode("Подписчик")
            action = Stack.create {
                spacing = responsive(2)
                direction = responsive(StackDirection.row)
                Button {
                    variant = ButtonVariant.contained
                    color = ButtonColor.primary
                    startIcon = mui.icons.material.Save.create()
                    onClick = { subscriberContext.save() }
                    disabled = subscriberContext.isSaved || currentSubscriber.hashCode() == updatedSubscriber.hashCode()
                    +"Сохранить"
                }
                Button {
                    variant = ButtonVariant.contained
                    color = ButtonColor.error
                    startIcon = mui.icons.material.DoDisturbAltSharp.create()
                    onClick = { subscriberContext.cancelChanges() }
                    disabled = subscriberContext.isSaved || currentSubscriber.hashCode() == updatedSubscriber.hashCode()
                    +"Отменить изменения"
                }
            }
        }
        Stack {
            this.direction = responsive(StackDirection.column)
            spacing = responsive(2)
            Grid {
                this.item = true
                asDynamic().xs = 12
                asDynamic().md = 6
                Grid {
                    container = true
                    direction = responsive(GridDirection.row)
                    spacing = responsive(2)
                    Grid {
                        item = true
                        asDynamic().xs = 4
                        MainCard {
                            sx {
                                height = 100.pct
                                padding = 0.px
                            }
                            title = "Контактные данные"
                            Stack {
                                this.direction = responsive(StackDirection.column)
                                spacing = responsive(2)
                                FormControl {
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    InputLabel {
                                        htmlFor = "subscriber-id-input"
                                        +"ID:"
                                    }
                                    OutlinedInput {
                                        color = InputBaseColor.secondary
                                        disabled = true
                                        value = currentSubscriber?.id ?: ""
                                        label = ReactNode("ID:")
                                    }
                                }
                                FormControl {
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    InputLabel {
                                        htmlFor = "subscriber-email-input"
                                        +"Email:"
                                    }
                                    OutlinedInput {
                                        color =
                                            if (updatedSubscriber?.email == currentSubscriber?.email) InputBaseColor.secondary else InputBaseColor.warning
                                        value = updatedSubscriber?.email ?: ""
                                        label = ReactNode("Email:")
                                        onChange = { e ->
                                            val value = e.target.asDynamic().value as String
                                            subscriberContext.update(currentSubscriber?.copy(email = value))
                                        }
                                    }
                                }
                                FormControlLabel {
                                    control = Checkbox.create {
                                        color =
                                            if (updatedSubscriber?.emailVerified == currentSubscriber?.emailVerified) CheckboxColor.secondary else CheckboxColor.warning
                                        onChange = { _, _ ->
                                            subscriberContext.update(currentSubscriber?.copy(emailVerified = !currentSubscriber.emailVerified))
                                        }
                                        checked = updatedSubscriber?.emailVerified ?: false
                                    }
                                    label = ReactNode("Email подтвержден")
                                }
                                FormControl {
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    InputLabel {
                                        htmlFor = "subscriber-phone-input"
                                        +"Телефон:"
                                    }
                                    OutlinedInput {
                                        color =
                                            if (updatedSubscriber?.phone == currentSubscriber?.phone) InputBaseColor.secondary else InputBaseColor.warning
                                        value = updatedSubscriber?.phone ?: ""
                                        label = ReactNode("Телефон:")
                                        onChange = { e ->
                                            val value = e.target.asDynamic().value as String
                                            subscriberContext.update(currentSubscriber?.copy(phone = value))
                                        }
                                    }
                                }
                                FormControlLabel {
                                    control = Checkbox.create {
                                        color = CheckboxColor.secondary
                                        onChange = { _, _ ->
                                            subscriberContext.update(currentSubscriber?.copy(phoneVerified = !currentSubscriber.phoneVerified))
                                        }
                                        checked = updatedSubscriber?.phoneVerified ?: false
                                    }
                                    label = ReactNode("Телефон подтвержден")
                                }
                                FormControl {
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    InputLabel {
                                        htmlFor = "subscriber-reg-date-input"
                                        +"Дата регистрации:"
                                    }
                                    OutlinedInput {
                                        color = InputBaseColor.secondary
                                        disabled = true
                                        value = currentSubscriber?.regDate?.toLocalString() ?: ""
                                        label = ReactNode("Дата регистрации:")
                                    }
                                }
                                StoresSelect {
                                    disabled = true
                                }
                                FormControlLabel {
                                    control = Checkbox.create {
                                        color = CheckboxColor.secondary
                                        onChange = { _, _ ->
                                        }
                                        checked = false
                                    }
                                    label = ReactNode("НЕ ОТПРАВЛЯТЬ! (Демо!!)")
                                }
                            }
                        }
                    }
                    Grid {
                        sx {
                            height = 100.pct
                        }
                        item = true
                        asDynamic().xs = 8
                        Stack {
                            spacing = responsive(2)
                            this.direction = responsive(StackDirection.column)
                            Card {
                                CardHeader {
                                    val lastDelivery = emailMessages
                                        .asSequence()
                                        .filter { it.status == 5 }
                                        .map { it.events }
                                        .flatten()
                                        .filterIsInstance<EmailMessageEvent.Delivery>()
                                        .map { it.timestamp }
                                        .lastOrNull()
                                    val lastOpen = emailMessages
                                        .asSequence()
                                        .filter { it.status == 7 }
                                        .map { it.events }
                                        .flatten()
                                        .filterIsInstance<EmailMessageEvent.Open>()
                                        .map { it.timestamp }
                                        .lastOrNull()
                                    title = if (emailMessagesInProcess) {
                                        CircularProgress.create {
                                            color = CircularProgressColor.secondary
                                        }
                                    } else {
                                        ReactNode("Статистика email")
                                    }
                                    this.action = Stack.create {
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(2)
                                        Typography {
                                            variant = TypographyVariant.caption
                                            gutterBottom = true
                                            sx {
                                                +theme.typography.menuCaption.unsafeCast<PropertiesBuilder>()
                                                display = Display.block
                                            }
                                            +"Последнее получение: ${lastDelivery?.toLocalString() ?: "---"}"
                                        }
                                        Typography {
                                            variant = TypographyVariant.caption
                                            gutterBottom = true
                                            sx {
                                                +theme.typography.menuCaption.unsafeCast<PropertiesBuilder>()
                                                display = Display.block
                                            }
                                            +"Последнее открытие: ${lastOpen?.toLocalString() ?: "---"}"
                                        }
                                    }
                                }
                                CardContent {
                                    val statusToShow = listOf(3, 5, 6, 7, 8)
                                    val events = emailMessages.map { it.events }.flatten()
                                    val sendStatusCount = events.filterIsInstance<EmailMessageEvent.Send>().size
                                    val deliveryStatusCount = events.filterIsInstance<EmailMessageEvent.Delivery>().size
                                    val errorsCount = (events.filterIsInstance<EmailMessageEvent.Bounce>().size
                                            + events.filterIsInstance<EmailMessageEvent.Reject>().size
                                            + events.filterIsInstance<EmailMessageEvent.Complaint>().size)
                                    val openCount = events.filterIsInstance<EmailMessageEvent.Open>().size
                                    val clickCount = events.filterIsInstance<EmailMessageEvent.Click>().size
                                    Table {
                                        TableHead {
                                            TableRow {
                                                EmailMessageStatus.titles.entries.forEach { (status, title) ->
                                                    if (statusToShow.contains(status)) {
                                                        TableCell {
                                                            +title
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        TableBody {
                                            TableRow {
                                                sx {
                                                    "&:last-child td, &:last-child th" {
                                                        border = Border(0.px, LineStyle.solid)
                                                    }
                                                }
                                                EmailMessageStatus.titles.entries.forEach { (status, _) ->
                                                    if (statusToShow.contains(status)) {
                                                        val count = when (status) {
                                                            3 -> "$sendStatusCount ( ${sendStatusCount * 100 / sendStatusCount} %)"
                                                            5 -> "$deliveryStatusCount ( ${deliveryStatusCount * 100 / sendStatusCount} %)"
                                                            6 -> "$errorsCount ( ${errorsCount * 100 / sendStatusCount} %)"
                                                            7 -> "$openCount ( ${openCount * 100 / deliveryStatusCount} %)"
                                                            8 -> "$clickCount ( ${clickCount * 100 / openCount} %)"
                                                            else -> ""
                                                        }
                                                        TableCell {
                                                            +count
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            Grid {
                                sx {
                                    height = 100.pct
                                }
                                Card {

                                    CardContent {
                                        Stack {
                                            this.direction = responsive(StackDirection.column)
                                            asDynamic().spacing = 2
                                            Typography {
                                                variant = TypographyVariant.caption
                                                gutterBottom = true
                                                +"Подписки (${currentSubscriber?.subscriptions?.size ?: 0})"
                                            }
                                            Grid {
                                                this.direction = responsive(GridDirection.row)
                                                container = true
                                                asDynamic().spacing = 2
                                                Grid {
                                                    item = true
                                                    Stack {
                                                        direction = responsive(StackDirection.row)
                                                        asDynamic().spacing = 1
                                                        sx {
                                                            alignItems = AlignItems.center
                                                            flexWrap = FlexWrap.wrap
                                                            this.gap = 3.px
                                                        }
                                                        if (currentSubscriber != null) {
                                                            sublistContext.lists.filter {
                                                                currentSubscriber.subscriptions!!.contains(
                                                                    it.id
                                                                )
                                                            }.forEach { list ->
                                                                Chip {
                                                                    key = list.id
                                                                    label = ReactNode(list.name)
                                                                }
                                                            }
                                                        }
                                                        Button {
                                                            +"Добавить"
                                                            startIcon =
                                                                mui.icons.material.AddCircleOutlineSharp.create()
                                                            onClick = {
                                                                showSubscribeDialog = true
                                                            }
                                                            variant = ButtonVariant.outlined
                                                            color = ButtonColor.secondary
                                                        }
                                                        Button {
                                                            startIcon = mui.icons.material.UnsubscribeSharp.create()
                                                            onClick = {
                                                                showUnSubscribeDialog = true
                                                            }
                                                            color = ButtonColor.error
                                                            variant = ButtonVariant.outlined
                                                            +"Отписать"
                                                        }
                                                    }
                                                }
                                            }
                                            Typography {
                                                variant = TypographyVariant.caption
                                                gutterBottom = true
                                                sx {
                                                    display = Display.block
                                                }
                                                +"Теги (${selectedTags.size})"
                                            }
                                            Grid {
                                                this.direction = responsive(GridDirection.row)
                                                container = true
                                                asDynamic().spacing = 2
                                                Grid {
                                                    item = true
                                                    Stack {
                                                        this.direction = responsive(StackDirection.row)
                                                        asDynamic().spacing = 1
                                                        sx {
                                                            alignItems = AlignItems.center
                                                            flexWrap = FlexWrap.wrap
                                                            this.gap = 3.px
                                                        }
                                                        selectedTags.forEach { tag ->
                                                            Chip {
                                                                deleteIcon = Cancel.create {
                                                                    onMouseDown = {
                                                                        it.stopPropagation()
                                                                    }
                                                                }
                                                                onDelete = {
                                                                    setSelectedTags {
                                                                        it.minus(tag)
                                                                    }
                                                                    subscriberContext.update(currentSubscriber?.copy())
                                                                }
                                                                key = tag
                                                                label = ReactNode(tag)
                                                            }
                                                        }
                                                        Button {
                                                            +"Добавить тег (Демо)"
                                                            startIcon =
                                                                mui.icons.material.AddCircleOutlineSharp.create()
                                                            variant = ButtonVariant.outlined
                                                            color = ButtonColor.secondary
                                                            onClick = {
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            MainCard {
                title = "Дополнительные поля"
                this.actions = Stack.create {
                    this.direction = responsive(StackDirection.row)
                    this.divider = Divider.create {
                        orientation = Orientation.vertical
                    }
                    asDynamic().spacing = 2
                    sx {
                        this.width = 100.pct
                        border = 2.px
                        this.alignItems = AlignItems.center
                        this.justifyContent = JustifyContent.flexStart
                    }
                    AvatarButton {
                        tooltipTitle = "Добавить поле"
                        mui.icons.material.AddCircleOutlineSharp()
                        onClick = {
                            navigate("/properties")
                        }
                    }
                    Button {
                        +if (!propertiesContext.emptyIsHidden) "Скрыть пустые" else "Показать все поля"
                        color = ButtonColor.secondary
                        variant = ButtonVariant.outlined
                        onClick = {
                            propertiesContext.hideEmpty()
                        }
                        this.startIcon = mui.icons.material.VisibilityOffSharp.create()
                    }
                }
                Stack {
                    direction = responsive(StackDirection.column)
                    spacing = responsive(2)
                    propertiesContext.propertiesList.forEach { property ->
                        val subscriberProperty =
                            currentSubscriber?.properties?.find { it.propertyId == property.id }
                        val propertyValues = when (subscriberProperty) {
                            is SubscriberDataProperty.BoolProperty -> subscriberProperty.values.map { it.toString() }
                            is SubscriberDataProperty.DateProperty -> subscriberProperty.values.map { it.toString() }
                            is SubscriberDataProperty.FloatProperty -> subscriberProperty.values.map { it.toString() }
                            is SubscriberDataProperty.IntProperty -> subscriberProperty.values.map { it.toString() }
                            is SubscriberDataProperty.StringProperty -> subscriberProperty.values.filter { it.isNotBlank() }
                            null -> {
                                listOf()
                            }
                        }
                        if (propertyValues.isNotEmpty() || !propertiesContext.emptyIsHidden) {
                            propertyField {
                                this.values = propertyValues
                                this.property = property
                                this.onChangeHandler = { value ->
                                    val list = currentSubscriber?.properties?.toMutableList()
                                    val newProperty =
                                        when (subscriberProperty) { //todo добавить проверку корректности заполнения
                                            is SubscriberDataProperty.BoolProperty -> subscriberProperty.copy(
                                                values = listOf(value.toBoolean())
                                            )

                                            is SubscriberDataProperty.DateProperty -> subscriberProperty.copy(
                                                values = listOf(value.toLocalDateTime().toInstant(TimeZone.UTC))
                                            )

                                            is SubscriberDataProperty.FloatProperty -> subscriberProperty.copy(
                                                values = listOf(value.toFloat())
                                            )

                                            is SubscriberDataProperty.IntProperty -> subscriberProperty.copy(
                                                values = listOf(value.toInt())
                                            )

                                            is SubscriberDataProperty.StringProperty -> subscriberProperty.copy(
                                                values = listOf(value)
                                            )

                                            null -> {
                                                when (property.type) {
                                                    PropertyType.String -> SubscriberDataProperty.StringProperty(
                                                        property.id,
                                                        listOf(value)
                                                    )

                                                    PropertyType.Int -> SubscriberDataProperty.IntProperty(
                                                        property.id,
                                                        listOf(value.toInt())
                                                    )

                                                    PropertyType.Float -> SubscriberDataProperty.FloatProperty(
                                                        property.id,
                                                        listOf(value.toFloat())
                                                    )

                                                    PropertyType.Date -> SubscriberDataProperty.DateProperty(
                                                        property.id,
                                                        listOf(value.toLocalDateTime().toInstant(TimeZone.UTC))
                                                    )

                                                    PropertyType.Bool -> SubscriberDataProperty.BoolProperty(
                                                        property.id,
                                                        listOf(value.toBoolean())
                                                    )
                                                }
                                            }
                                        }
                                    if (list != null) {
                                        val index = currentSubscriber.properties.indexOfFirst {
                                            it.propertyId ==
                                                    subscriberProperty?.propertyId
                                        }
                                        if (index > -1) {
                                            list[index] = newProperty
                                            subscriberContext.update(currentSubscriber.copy(properties = list))
                                        } else {
                                            subscriberContext.update(
                                                currentSubscriber.copy(
                                                    properties = list.plus(
                                                        newProperty
                                                    )
                                                )
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

external interface PropertyFieldProps: Props{
    var property: Property
    var onChangeHandler: (String) -> Unit
    var values: List<String>
}

val propertyField = FC<PropertyFieldProps> { props ->
    var value by useState(props.values.joinToString(", "))
    val isCorrect = useMemo(value) {
        if (value.isBlank()) {
            true
        } else {
            when (props.property.type) {
                PropertyType.String -> true
                PropertyType.Int -> try {
                    value.toInt()
                    true
                } catch (e: Exception) {
                    false
                }

                PropertyType.Float -> try {
                    value.toFloat()
                    true
                } catch (e: Exception) {
                    false
                }

                PropertyType.Date -> try {
                    value.toLocalDateTime().toInstant(TimeZone.UTC)
                    true
                } catch (e: Exception) {
                    false
                }

                PropertyType.Bool -> try {
                    value.toBoolean()
                    true
                } catch (e: Exception) {
                    false
                }
            }
        }
    }
    Grid {
        container = true
        spacing = responsive(1)
        sx {
            alignItems = AlignItems.flexStart
        }
        Grid {
            item = true
            asDynamic().xs = 1
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(1)
                Tooltip {
                    mui.icons.material.InfoSharp {
                        color = SvgIconColor.info
                    }
                    title = ReactNode(props.property.type.title)
                }
                Typography {
                    +"${props.property.name}:"
                }

            }
        }
        Grid {
            item = true
            asDynamic().xs = 10
            FormControl {
                variant = FormControlVariant.outlined
                fullWidth = true
                error = !isCorrect

                when (props.property.type) {
                    PropertyType.String -> {
                        OutlinedInput {
                            color = InputBaseColor.secondary
                            this.value = value //todo Видимо надо через render input
                            onChange = { e ->
                                value = e.target.asDynamic().value as String
                            }
                        }
                    }

                    PropertyType.Int -> {
                        OutlinedInput {
                            color = InputBaseColor.secondary
                            this.value = value //todo Видимо надо через render input
                            onChange = { e ->
                                val newValue = e.target.asDynamic().value as String
                                value = newValue
                            }
                        }
                        if (!isCorrect) FormHelperText {
                            this.error = true
                            +"Значение должно быть целочисленным"
                        }
                    }

                    PropertyType.Float -> {
                        OutlinedInput {
                            color = InputBaseColor.secondary
                            inputMode = InputMode.decimal
                            this.value = value
                            onChange = { e ->
                                val newValue = e.target.asDynamic().value as String
                                value = newValue
                            }
                        }
                        if (!isCorrect) FormHelperText {
                            this.error = true
                            +"Значение должно быть числом с точкой"
                        }
                    }

                    PropertyType.Date -> {
                        TextField {
                            color = TextFieldColor.secondary
                            error = !isCorrect
                            type = InputType.datetimeLocal
                            this.value = value
                            onChange = { e ->
                                val newValue = e.target.asDynamic().value as String
                                value = newValue
                            }
                            if (!isCorrect) helperText = ReactNode("Некорректный формат даты")
                        }
                    } //todo использовать datefield
                    PropertyType.Bool -> {
                        Select {
                            color = InputBaseColor.secondary
                            this.value = value
                            onChange = { e, _ ->
                                value = e.target.value
                            }
                            MenuItem {
                                this.value = "true"
                                +"Да"
                            }
                            MenuItem {
                                this.value = "false"
                                +"Нет"
                            }
                        }
                    }
                }
            }
        }
        Grid {
            item = true
            asDynamic().xs = 1
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                if (value != props.values.joinToString(", ")) {
                    Tooltip {
                        title = ReactNode("Подтвердить")
                        IconButton {
                            disabled = !isCorrect
                            mui.icons.material.DoneSharp {
                                color = if (isCorrect) {
                                    SvgIconColor.success
                                } else {
                                    SvgIconColor.disabled
                                }
                            }
                            onClick = {
                                props.onChangeHandler(value)
                            }
                        }
                    }
                    Tooltip {
                        title = ReactNode("Отменить")
                        IconButton {
                            mui.icons.material.ClearSharp {
                                color = SvgIconColor.error
                            }
                            onClick = {
                                value = props.values.joinToString(", ")
                            }
                        }
                    }
                }
            }
        }
    }
}
